import Vue from "vue";
import Router from "vue-router";
import Store from "@/store";
import BaseLayout from "@/views/layout/BaseLayout";
import PdfLayout from "@/views/layout/PdfLayout";
import settings from "@/service/Settings";
import OidcAuthenticate from "./views/auth/OidcAuthenticate.vue";
import OidcSilent from "./views/auth/OidcSilent.vue";
import OidcSignIn from "@/views/auth/OidcSignIn.vue";

Vue.use(Router);
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: BaseLayout,

      children: [
        {
          path: "",
          name: "landing",
          component: () =>
            import(/* webpackChunkName: "base" */ "./views/Landing.vue"),
        },
        {
          path: "/acknowledgement",
          name: "",
          component: () =>
            import(
              /* webpackChunkName: "acknowledgement" */ "./views/Acknowledgement.vue"
            ),
        },
        {
          path: "/advanced",
          name: "advanced",
          props: true,
          component: () =>
            import(/* webpackChunkName: "advanced" */ "./views/Advanced.vue"),
        },
        {
          path: "/emergency-driver",
          name: "emergencyDriver",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "advanced" */ "./views/product/EmergencyDriver.vue"
            ),
        },
        {
          path: "/search",
          name: "search",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "search" */ "./views/search/Search.vue"
            ),
        },
        {
          path: "/dummy-auth-login",
          name: "dummyAuthLogin",
          component: () =>
            import(
              /* webpackChunkName: "dummy-auth-login" */ "./views/DummyAuthLogin.vue"
            ),
        },
        {
          path: "/saved-filters",
          name: "savedFilters",
          component: () =>
            import(
              /* webpackChunkName: "saved-filters" */ "./views/profile/SavedFilters.vue"
            ),
        },
        {
          path: "/saved-solutions",
          name: "savedSolutions",
          component: () =>
            import(
              /* webpackChunkName: "saved-solutions" */ "./views/profile/SavedSolutions.vue"
            ),
        },
        {
          path: "/saved-views",
          name: "savedViews",
          component: () =>
            import(
              /* webpackChunkName: "saved-solutions" */ "./views/profile/SavedViews.vue"
            ),
        },
        {
          path: "/advanced/:12nc/:type",
          name: "advancedFiltered",
          redirect: (to) => {
            return {
              name: "advanced",
              params: {
                searchItem: {
                  nc12: to.params["12nc"],
                  type: to.params.type.toLowerCase(),
                },
              },
            };
          },
        },
        {
          path: "/share",
          name: "share",
          redirect: (to) => {
            if (to.query.region) {
              Store.dispatch("brain/switchRegion", {
                region: to.query.region,
                clearSolution: true,
              });
            }

            if (to.query.type === "emergency-driver") {
              return {
                name: "emergencyDriver",
                params: {
                  searchItem: {
                    nc12: to.query.nc12,
                  },
                },
                query: {},
              };
            }

            return {
              name: "advanced",
              params: {
                searchItem: {
                  nc12: to.query.nc12,
                  type: to.query.type,
                  settings: JSON.parse(
                    decodeURIComponent(escape(atob(to.query.settings)))
                  ),
                },
              },
            };
          },
        },
      ],
    },
    {
      path: "/oidc-authenticate*",
      name: "oidc-authenticate",
      component: OidcAuthenticate,
    },
    {
      path: "/oidc-silent*",
      name: "oidc-silent",
      component: OidcSilent,
    },
    {
      path: "/oidc-sso*",
      name: "oidc-sso",
      component: OidcSignIn,
    },
    {
      path: "/pdf-solution",
      name: "pdfSolution",
      component: PdfLayout,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const currentRegion = Store.state.brain.region;
  if (to.query.region && to.query.region !== currentRegion) {
    Store.dispatch("brain/switchRegion", {
      region: to.query.region,
      clearSolution: true,
    });
  } else {
    try {
      const region = localStorage.getItem("region");
      if (region && region !== currentRegion) {
        Store.dispatch("brain/switchRegion", {
          region: region,
          clearSolution: true,
        });
      }
    } catch (e) {
      /* Local storage not available */
    }
  }

  if (to.name === "dummyAuthLogin" && settings.ENV !== "local") {
    next({ name: "landing" });
  } else {
    next();
  }
});
export default router;
